import React from 'react';
import { Redirect, withRouter } from 'react-router';
import TerminosCondiciones from '../../TerminosCondiciones';
import Header from '../Header/';
import './consultar.scss';
import useResizeEventIframe from '../../Utils/Iframe';
import headerCupra from '../../App/imgs/cupra/cupra-header-consultar.png';
import headerCupraMd from '../../App/imgs/cupra/cupra-header-consultar-md.png';
import headerCupraSm from '../../App/imgs/cupra/cupra-header-consultar-sm.png';
import Input from '../../componentes/cupra/controls/Input/index.js'
import ButtonPrimary from '../../componentes/cupra/controls/ButtonPrimary/index.js'
import SecondaryButton from '../../componentes/cupra/controls/SecondaryButton/index.js'
import ir from '../../media/iconos/cupra/ir.svg';
import Loading from '../../componentes/cupra/controls/Loading/index.js';

class Consultar extends React.Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeEmail = this.handleChangeEmail.bind(this);
        this.state = {
            errorlabel: false,
            idCompra: "",
            modal: false,
            errorlabelcorreo: false,
            correo: "",
            responseBody: undefined,
            errornumero: false,
            errortexto: "",
            errortitulo: "",
            cargando: false,
            aceptoTerminos: false
        };
        this.ref = React.createRef();
        try {
            if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
                this.props.servicioFirebase.registrarPaginaVisitadaAnalitica(window.location.origin, window.location.pathname, "Consultar");
            }
        } catch (err) {
            console.error("error: ", err);
        }
    }

    construirMascara = (pasos) => {
        let dataFiltered = pasos.otrosEstatus.filter(function (status) {
            return status.nombreEstatus === 'Solicitud de crédito' || status.nombreEstatus === 'Autorización de crédito'
                || status.nombreEstatus === 'Entrega de auto' || status.nombreEstatus === 'Pago de enganche' || status.nombreEstatus === 'Vehículo Entregado';
        });

        pasos.otrosEstatus = dataFiltered

        let estatusActualName = pasos.estatusActual.nombreEstatus

        if (estatusActualName === "Solicitud de crédito") {
            pasos.estatusActual.nombreEstatus = "Conocimiento y Cotización"
            pasos.estatusActual.mensajeFuente = "Te informamos que estamos trabajando en la aprobación de la cotización para tu Nuevo CUPRA."
        } else if (estatusActualName === "Autorización de crédito") {
            pasos.estatusActual.nombreEstatus = "Financiamiento autorizado"
            pasos.estatusActual.mensajeFuente = "Tenemos una excelente noticia, el financiamiento para adquirir tu Nuevo CUPRA ha sido aprobado."
        } else if (estatusActualName === "Pago de enganche") {
            pasos.estatusActual.nombreEstatus = "Enganche pagado"
            pasos.estatusActual.mensajeFuente = "Te confirmamos que hemos recibido el pago de enganche para tu Nuevo CUPRA."
        } else if (estatusActualName === "Entrega de auto") {
            pasos.estatusActual.nombreEstatus = "Por entregar"
            pasos.estatusActual.mensajeFuente = "Estás a pocos días de experimentar el ADN CUPRA. ¿Estás listo para ser uno de nosotros?"
        } else if (estatusActualName === "Vehículo Entregado") {
            pasos.estatusActual.nombreEstatus = "Entrega realizada"
            pasos.estatusActual.mensajeFuente = "Ya eres uno de nosotros y queremos confirmarte que hemos realizado la entrega de tu Nuevo CUPRA."
        }


        for (let i = 0; i < pasos.otrosEstatus.length; i++) {
            let statusName = pasos.otrosEstatus[i].nombreEstatus
            if (statusName === "Solicitud de crédito") {
                pasos.otrosEstatus[i].nombreEstatus = "Conocimiento y Cotización"
                pasos.otrosEstatus[i].mensajeFuente = "Te informamos que estamos trabajando en la aprobación de la cotización para tu Nuevo CUPRA."
            } else if (statusName === "Autorización de crédito") {
                pasos.otrosEstatus[i].nombreEstatus = "Financiamiento autorizado"
                pasos.otrosEstatus[i].mensajeFuente = "Tenemos una excelente noticia, el financiamiento para adquirir tu Nuevo CUPRA ha sido aprobado."
            } else if (statusName === "Pago de enganche") {
                pasos.otrosEstatus[i].nombreEstatus = "Enganche pagado"
                pasos.otrosEstatus[i].mensajeFuente = "Te confirmamos que hemos recibido el pago de enganche para tu Nuevo CUPRA."
            } else if (statusName === "Entrega de auto") {
                pasos.otrosEstatus[i].nombreEstatus = "Por entregar"
                pasos.otrosEstatus[i].mensajeFuente = "Estás a pocos días de experimentar el ADN CUPRA. ¿Estás listo para ser uno de nosotros?"
            }  else if (statusName === "Vehículo Entregado") {
                pasos.otrosEstatus[i].nombreEstatus = "Entrega realizada"
                pasos.otrosEstatus[i].mensajeFuente = "Ya eres uno de nosotros y queremos confirmarte que hemos realizado la entrega de tu Nuevo CUPRA."
            }
        }

        return pasos
    }

    handleChange(event) {
        var pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        if (pattern.test(event.target.value)) {
            this.setState({ errorlabel: false, idCompra: event.target.value });
        } else {
            this.setState({ errorlabel: true });
        }
    }

    setAceptoTerminos = (callback) => {

        this.setState({ aceptoTerminos: callback });
    }

    handleChangeEmail(event) {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (pattern.test(event.target.value)) {
            this.setState({ errorlabelcorreo: false, correo: event.target.value });
        } else {
            this.setState({ errorlabelcorreo: true });
        }
    }

    despliegaModal() {
        if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
            this.props.servicioFirebase.registrarEventoPersonalizadoAnalitica("action-despliegue-modal", { marca: this.props.marca, descripcion: "Despliegue de modal" });
        }
        this.setState({ modal: true });
    }

    quitaModal() {
        if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
            this.props.servicioFirebase.registrarEventoPersonalizadoAnalitica("action-quita-modal", { marca: this.props.marca, descripcion: "Cierre  del modal" });
        }
        this.setState({ modal: false });
    }

    quitaModalError() {
        if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
            this.props.servicioFirebase.registrarEventoPersonalizadoAnalitica("action-quita-error-modal", { marca: this.props.marca, descripcion: "Cierre  del modal del error" });
        }
        this.setState({ errornumero: false });
        this.quitaModal();
    }

    nombreMarca() {
        switch (this.props.marca) {
            case 'audi':
                return "Audi";
            case 'seat':
                return "SEAT";
            case 'vw':
                return "Volkswagen";
            case 'cupra':
                return "Cupra";
            default: return '';
        }
    }

    async enviaNumeroGUIA() {
        if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
            this.props.servicioFirebase.registrarEventoPersonalizadoAnalitica("action-envia-numero-guia", { marca: this.props.marca, descripcion: "Envio de numero de guía" });
        }

        this.setState({ cargando: true });
        var pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        if (pattern.test(this.state.idCompra)) {
            this.setState({ errorlabel: false, cargando: true });
            fetch(process.env.REACT_APP_URL_DTO_BACK + "status?idCompra=" + this.state.idCompra, {
                method: "GET",
                headers: {
                    "Authorization": "Bearer " + process.env.REACT_APP_TOKEN_AUTH
                }
            }).then(async res => {
                let responseBody = await res.json();
                responseBody = responseBody.mensaje
                fetch(process.env.REACT_APP_URL_DTO_GLOBAL + "concesionaria?numConcesionaria=" + responseBody.numeroConcesionaria, {
                    method: "GET",
                    headers: {
                        "Authorization": "Bearer " + process.env.REACT_APP_TOKEN_AUTH
                    }
                }).then(async res => {
                    let responseBodyConce = await res.json();

                    if (this.props.marca === "cupra") {
                        let mascara = this.construirMascara(responseBody)
                        this.setState({ responseBody: { estatusActual: mascara.estatusActual, otrosEstatus: mascara.otrosEstatus, concesionaria: responseBodyConce.mensaje }, cargando: false });
                    } else {
                        this.setState({ responseBody: { estatusActual: responseBody.estatusActual, otrosEstatus: responseBody.otrosEstatus, concesionaria: responseBodyConce.mensaje }, cargando: false });
                    }
                }).catch(errorP => {
                    console.log(errorP);
                    this.setState({ errornumero: true, errortexto: "No encontramos el número guía o estamos presentando problemas.", errortitulo: "", cargando: false });
                });
            }).catch(errorP => {
                if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
                    this.props.servicioFirebase.registrarErrorAnalitica(errorP, true);
                }
                console.log(errorP);
                this.setState({ errornumero: true, errortexto: "No encontramos el número guía o estamos presentando problemas.", errortitulo: "", cargando: false });
            });
        } else {
            this.setState({ errorlabel: true, cargando: false });
        }
    }

    async recuperaNumeroGUIA() {
        if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
            this.props.servicioFirebase.registrarEventoPersonalizadoAnalitica("action-recupera-numero-guia", { marca: this.props.marca, descripcion: "Busqueda de numero de guía" });
        }

        this.setState({ cargando: true });
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (pattern.test(this.state.correo)) {
            this.setState({ errorlabel: false });
            fetch(process.env.REACT_APP_URL_DTO_BACK + "recuperarguia?correo=" + this.state.correo + "&marca=" + (this.props.marca === "vw" && window.location.pathname.startsWith("/es/app/sigue-tu-volkswagen/") ? "nfz" : this.props.marca), {
                method: "GET",
                headers: {
                    "Authorization": "Bearer " + process.env.REACT_APP_TOKEN_AUTH
                }
            }).then(async res => {
                await res.json();
                this.setState({ cargando: false, errornumero: true, errortexto: "El número guía se envío al correo que ingresaste.", errortitulo: "" });
            }).catch(errorP => {
                if (this.props.marca !== process.env.REACT_APP_MARCA_VW) {
                    this.props.servicioFirebase.registrarErrorAnalitica(errorP, true);
                }
                console.log(errorP);
                this.setState({ cargando: false, errornumero: true, errortexto: "Por el momento no podemos recuperar el número de guía, intente más tarde.", errortitulo: "" });
            });
        } else {
            this.setState({ errorlabelcorreo: true, cargando: false });
        }
    }



    render() {
        let ResizeEventIframe = () => { useResizeEventIframe(this.ref); return null };

        return <div ref={this.ref}>

            {this.props.marca === 'audi' && <ResizeEventIframe />}
            {this.state.responseBody === undefined ? (
                this.state.aceptoTerminos === false ? <TerminosCondiciones marca={this.props.marca} servicioFirebase={this.props.servicioFirebase} servicio={this.props.servicio} callbackAceptoTerminos={this.setAceptoTerminos} mostrarMenu={false} mostrarFooter={false} /> :

                    <div>
                        {this.props.marca === "vw" && <Header marca={this.props.marca} nfz={this.props.location.pathname.startsWith("/es/app/sigue-tu-volkswagen/vw/")} />}

                        <div>


                            {this.props.marca !== "cupra" ?

                                <div className="container">
                                    <div className="col col-md-8 offset-md-2 pt-5">
                                        {
                                            this.props.marca === "audi" ? (
                                                <h2>Bienvenido</h2>
                                            ) : (this.props.marca === "vw" ? (
                                                <h1 className="container__titulo--vw  font__title--ligth">Sigue tu<br /> <span className="font__title--bold">Volkswagen</span></h1>
                                            ) : (
                                                this.props.marca === "seat" ? (
                                                    <div className="container__titulo--seat">
                                                        <h2>Bienvenido</h2>
                                                    </div>
                                                ) : ""
                                            )
                                            )
                                        }
                                    </div>
                                    <div className={"col col-md-8 offset-md-2" + (this.props.marca === "audi" ? " pt-5 pb-5" : this.props.marca === "vw" ? " mt-5 mb-3" : " pt-5 pb-5 pasos__containertitulo--seat")}>
                                        <p><span className={"pasos__titulo--" + this.props.marca}>Favor de ingresar</span> tu  número GUÍA:</p>
                                        <div className="form-group">
                                            <input type="text" className={"w-100 form-control form-control-lg form__input--" + this.props.marca + (this.state.errorlabel ? " form__input--" + this.props.marca + "-error" : "")} maxLength="36" onChange={this.handleChange} />
                                            <span className={this.state.errorlabel ? "form__errorlabel--" + this.props.marca : "d-none"}>* Favor de validar el número de seguimiento</span>
                                            <div className={"row mb-2" + (this.props.marca === "audi" ? " mt-3" : this.props.marca === "vw" ? " mt-5" : "")}>
                                                <div className="col-xs-12 col-md-6 mt-3">
                                                    <button className={"w-100 form__button--" + this.props.marca + "-ghost form__button--" + this.props.marca} name="recuperar" onClick={() => { this.despliegaModal() }}>Recuperar</button>
                                                </div>
                                                <div className="col-xs-12 col-md-6 mt-3">
                                                    <button className={"w-100 form__button--" + this.props.marca + "-black form__button--" + this.props.marca} onClick={() => { this.enviaNumeroGUIA() }} name="consultar">Consultar</button>
                                                </div>
                                            </div>
                                            {this.props.marca !== "vw" && <p className={"mt-4 cursor-pointer texto--" + this.props.marca + "-hover"} onClick={() => this.props.history.push("/" + this.props.marca + "/inicio")}><b>Acceder a más funcionalidades de Sigue tu {this.nombreMarca()} </b>
                                                {
                                                    this.props.marca === "seat" ? (
                                                        <svg width="8px" height="14px" viewBox="0 0 8 14" version="1.1" xmlns="http://www.w3.org/2000/svg" >
                                                            <g id="" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                                <g id="color" transform="translate(-164.000000, -22.000000)" fill="#0f0f0f">
                                                                    <g id="" transform="translate(24.000000, 16.000000)">
                                                                        <polygon id="" transform="translate(144.000000, 12.500000) rotate(-90.000000) translate(-144.000000, -12.500000) " points="148.971417 8.5 144.001083 13.4435897 139.029667 8.5 139.0275 8.5 137.5 10.0211876 144.001083 16.5 150.5 10.0211876 148.973583 8.5"></polygon>
                                                                    </g>
                                                                </g>
                                                            </g>
                                                        </svg>
                                                    ) : (this.props.marca === "audi" ? (
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" >
                                                            <path stroke="currentColor" strokeWidth="1px" fill="none" d="M1.5,1l5.485,5.504l-5.48,5.496"></path>
                                                        </svg>
                                                    ) : "")
                                                }
                                            </p>}
                                        </div>
                                    </div>
                                    <div className={"modal fade show form__modal " + (this.state.modal ? "d-block" : "d-none")} id="modal" role="dialog" aria-labelledby="modal" aria-hidden="true" >
                                        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { this.quitaModal() }}>
                                                        <svg width="48" height="48" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                                            <title>
                                                                cancel-large
                                                            </title>
                                                            <path d="M31.6,15.4 L15.4,31.6 M15.4,15.4 L31.7,31.7" stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd" />
                                                        </svg>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <h5 className="modal-title font-weight-bold" id="exampleModalLongTitle">Recuperar Número GUÍA</h5><br></br>
                                                    <p>Favor de ingresar el correo electrónico con el que se generó tu  número GUÍA: </p>
                                                    <input type="text" className={"w-100 form-control form-control-lg form__input--" + this.props.marca + (this.state.errorlabelcorreo ? " form__input--" + this.props.marca + "-error" : "")} onChange={this.handleChangeEmail} />
                                                    <span className={this.state.errorlabelcorreo ? "form__errorlabel--" + this.props.marca : "d-none"}>* Favor de validar el correo electrónico</span>
                                                </div>
                                                <div className="modal-footer">
                                                    <button className={"w-100 form__button--" + this.props.marca + "-black form__button--" + this.props.marca} onClick={() => { this.recuperaNumeroGUIA(); }} name="consultar">Recuperar</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={"modal fade show form__modal " + (this.state.errornumero ? "d-block" : "d-none")} id="modal" role="dialog" aria-labelledby="modal" aria-hidden="true" >
                                        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { this.quitaModalError() }}>
                                                        <svg width="48" height="48" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                                            <title>
                                                                cancel-large
                                                            </title>
                                                            <path d="M31.6,15.4 L15.4,31.6 M15.4,15.4 L31.7,31.7" stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd" />
                                                        </svg>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <h5 className="modal-title" id="exampleModalLongTitle">{this.state.errortitulo}</h5>
                                                    <br></br>
                                                    <p className="text-center">{this.state.errortexto}</p>
                                                    <br></br>
                                                </div>
                                                <div className="modal-footer">
                                                    <button className={"w-100 form__button--" + this.props.marca + "-black form__button--" + this.props.marca} onClick={() => { this.quitaModalError() }}>Cerrar</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"page__cargando page__cargando--" + this.props.marca + (this.state.cargando ? " d-block" : " d-none")}>

                                    </div>
                                </div>

                                :

                                <>

                                    <div className={"conteiner-header-cupra" + (this.props.marca === "cupra" ? "-visible" : "")}>
                                        <img className='d-none d-lg-block consulta-img-header-cupra' src={headerCupra} alt="header_kmi_cupra" />
                                        <img className='d-none d-md-block d-lg-none consulta-img-header-cupra' src={headerCupraMd} alt="header_kmi_cupra" />
                                        <img className='d-block d-md-none consulta-img-header-cupra' src={headerCupraSm} alt="header_kmi_cupra" />
                                        <div className='img-text-cupra' />
                                    </div>

                                    <label className='d-none d-md-flex consulta-title'>Bienvenido a SIGUE TU CUPRA</label>

                                    <label className='d-flex d-md-none consulta-title'>Bienvenido a</label>
                                    <label className='d-flex d-md-none consulta-title'>SIGUE TU CUPRA</label>

                                    <div className='consulta-panel'>
                                        <label className="consulta-subtitle">Favor de ingresar tu  número guía:</label>
                                        <Input inputLabel={"Número de guía"}
                                            onChange={(e) => this.handleChange(e)}
                                            state={this.state}
                                            errorGuiaText={"Número de guía incorrecto, revisa de nuevo."}
                                            name={"numeroGuia"} required showErrorGuiaLabel textHidden />
                                    </div>

                                    <div className={"d-none d-md-flex consulta-containerButton"}>
                                        <SecondaryButton title={"Recuperar"} onButtonClickListener={() => this.despliegaModal()} />
                                        <ButtonPrimary textButton={"Continuar"} disabled={this.state.idCompra === "" || this.state.errorlabel} onClick={() => this.enviaNumeroGUIA()} />
                                    </div>

                                    <div className={'d-sm-flex d-md-none btns-panel'}>
                                        <div className={'margen_btw_btns'}>
                                            <SecondaryButton title={"Recuperar"} onButtonClickListener={() => this.despliegaModal()} />
                                        </div>
                                        <ButtonPrimary textButton={"Continuar"} disabled={this.state.idCompra === "" || this.state.errorlabel} onClick={() => this.enviaNumeroGUIA()} />
                                    </div>

                                    <div className='masPanel d-none d-md-flex' onClick={() => this.props.history.push("/" + this.props.marca + "/inicio")}>
                                        <label className='masCupra'>Acceder a más funcionalidades de SIGUE TU CUPRA</label>
                                        <img className='imga' src={ir} alt="ir a" />
                                    </div>

                                    <div className='masPanel d-sm-flex d-md-none' onClick={() => this.props.history.push("/" + this.props.marca + "/inicio")}>
                                        <label className='masCupra'>Acceder a más funcionalidades de <br /> SIGUE TU CUPRA <img className='imga' src={ir} alt="ir a" /></label>
                                    </div>

                                    {/** modal para recuperar guia */}
                                    {
                                        !this.state.cargando ?

                                            <div className={"modal fade show form__modal " + (this.state.modal ? "d-block" : "d-none")} id="modal" role="dialog" aria-labelledby="modal" aria-hidden="true" >
                                                <div className="modal-recuperar-guia modal-dialog-centered" role="document">
                                                    <div className="modal-content">
                                                        <div className="modal-header">
                                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { this.quitaModal() }}>
                                                                <svg width="48" height="48" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                                                    <title>
                                                                        cancel-large
                                                                    </title>
                                                                    <path d="M31.6,15.4 L15.4,31.6 M15.4,15.4 L31.7,31.7" stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                        <div className="modal-body p-md-4 p-lg-5">

                                                            <div className='d-block d-sm-none'>
                                                                <h4 className={"consulta-modal--titulo"}>Recuperar <br/>número de guía</h4>
                                                            </div>
                                                            <div className='d-none d-sm-block'>
                                                                <h4 className={"consulta-modal--titulo"}>Recuperar número de guía</h4>
                                                            </div>

                                                            <div className={"row consulta-modal--texto"}>
                                                                <p className="">Favor de ingresar el correo electrónico con el que se generó el número de guía:</p>
                                                            </div>
                                                            <div className='consulta-modal-input'>
                                                                <Input inputLabel={"Correo electrónico"}
                                                                    onChange={(e) => this.handleChangeEmail(e)}
                                                                    state={this.state}
                                                                    errorMailText={"Correo electrónico incorrecto, revisa de nuevo."}
                                                                    name={"correo"} required showErrorMailLabel />
                                                            </div>
                                                            <div className="container">
                                                                <div className='row consulta-modal--button'>
                                                                    <ButtonPrimary textButton={"Recuperar"} disabled={this.state.errorlabelcorreo || this.state.correo.length === 0} onClick={() => {
                                                                        this.recuperaNumeroGUIA()
                                                                        this.quitaModal()
                                                                    }} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            :

                                            <Loading />
                                    }

                                    {/** recuperar guia respuesta*/}

                                    <div className={"modal fade show form__modal " + (this.state.errornumero ? "d-block" : "d-none")} id="modal" role="dialog" aria-labelledby="modal" aria-hidden="true" >
                                        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => { this.quitaModalError() }}>
                                                        <svg width="48" height="48" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                                            <title>
                                                                cancel-large
                                                            </title>
                                                            <path d="M31.6,15.4 L15.4,31.6 M15.4,15.4 L31.7,31.7" stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd" />
                                                        </svg>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <h4 className={"consulta-modal--titulo"}>{this.state.errortitulo}</h4>
                                                    <div className="row consulta-modal--texto">
                                                        <p className="col-12">{this.state.errortexto}</p>
                                                    </div>
                                                    <div className="container">
                                                        <div className='row consulta-modal--button'>
                                                            <ButtonPrimary textButton={"Cerrar"} disabled={false} onClick={() => {
                                                                this.quitaModalError()
                                                            }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
            ) : (
                <Redirect to={{
                    pathname: this.props.marca !== "vw" && this.props.location.pathname.startsWith("/es/app/sigue-tu-volkswagen/vw/") !== true ?

                        "/" + this.props.marca + "/compra" :

                        (this.props.marca === "vw" && this.props.location.pathname.startsWith("/es/app/sigue-tu-volkswagen/vw/") !== true ?

                            "/app/sigue-tu-volkswagen/vw/compra" :

                            (this.props.marca === "vw" && this.props.location.pathname.startsWith("/es/app/sigue-tu-volkswagen/vw/") === true ?

                                "/es/app/sigue-tu-volkswagen/vw/compra.html" : "")), state: this.state.responseBody
                }} />
            )
            }
        </div>
    }
}

export default withRouter(Consultar);